import React, { useEffect, useState } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Components
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../app/common-components/CustomModal";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown";
import DiscardChanges from "../../../../app/common-components/DiscardChanges";
import FormCheck from "../../../../app/common-components/form/checkbox";
import Input from "../../../../app/common-components/form/input";
import Spinners from "../../../../app/common-components/Spinner";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice";
import { setToolsName, setToolsPlugin } from "../../configurationSlice";

//Sclice
import { configurationApi } from "../../../../app/services/configurationApi";
import { getConfigToolsList } from "./ToolsSlice";

// Assets
import { settingsCode8, StopNew } from "../../../../assets/images";

// 3rd Party Libraries
import { isEmpty } from "lodash";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import GetProxy from "../../../../app/GetProxy";

// Utils
import { useCommonAlert } from "../../../../app/utilities/helpers";

//Styles
import "../../../../app/common-components/DrillDown/features.common.styles.scss";
import "./styles.scss";

const timeStamp = new Date().getTime();
const proxy = GetProxy();

// Keys must match API response field names (value 1 = show, 0 = hide).
// `name` maps to the corresponding key in state.formData.
const FIELD_UI_CONFIG = {
  username: { label: "Username*", type: "text", name: "userName", placeholder: "Enter Username", masked: false },
  password: { label: "Password*", type: "password", name: "password", placeholder: "Enter Your Password", masked: true },
  url: { label: "URL*", type: "text", name: "url", placeholder: "Enter Your Tool URL", masked: false },
  apiToken: { label: "API Token", type: "text", name: "apiToken", placeholder: "Paste Your Tool API Token", masked: false },
  accessKey: { label: "Access Key*", type: "password", name: "accessKey", placeholder: "Enter Your Access Key", masked: true },
  secretAccessKey: { label: "Secret Access Key*", type: "password", name: "secretAccessKey", placeholder: "Enter Your Secret Access Key", masked: true },
  model: { label: "Model*", type: "text", name: "model", placeholder: "Enter Model Name", masked: false },
};

const resolveToolName = (t) =>
  typeof t === "string" ? t : t?.name || t?.toolName || "";

// Returns the ordered list of FIELD_UI_CONFIG keys that should be shown
// for the given tool, based on API response values (1 = show, 0 = hide).
// Returns null if the tool is not found (triggers default fallback).
const getToolFieldConfig = (toolsFieldsData, toolName) => {
  const tool = toolsFieldsData?.find((t) => resolveToolName(t) === toolName);
  if (!tool || typeof tool === "string") { return null; }
  return Object.keys(FIELD_UI_CONFIG).filter((key) => !!tool[key]);
};

// Renders form inputs dynamically based on the API-driven field configuration.
const ToolFormFields = ({ toolsFieldsData, toolName, formData, state, onChange, action }) => {
  if (!toolName) { return null; }

  const activeFieldKeys = getToolFieldConfig(toolsFieldsData, toolName);

  // Fallback to basic fields when the API has no config for this tool
  const fieldsToRender = activeFieldKeys
    ? activeFieldKeys.map((key) => FIELD_UI_CONFIG[key])
    : Object.values(FIELD_UI_CONFIG).filter((f) =>
      ["userName", "password", "url"].includes(f.name)
    );

  if (fieldsToRender.length === 0) {
    return (
      <div className="col-12">
        <p className="tool-no-fields">No configurable fields for this tool.</p>
      </div>
    );
  }

  return fieldsToRender.map((cfg) => (
    <Input
      key={cfg.name}
      type={cfg.masked ? "password" : "text"}
      label={cfg.label}
      error={state[`${cfg.name}Error`]}
      errorMessage={state[`${cfg.name}ErrorMessage`]}
      value={formData[cfg.name] || ""}
      onChange={(e) => onChange(e.target.name, e.target.value)}
      name={cfg.name}
      placeholder={cfg.placeholder}
      autoComplete="off"
      showPasswordToggle={cfg.masked && action !== "edit"}
    />
  ));
};

const Tools = (props) => {
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [createTools] = configurationApi.useCreateToolsMutation();
  const [changeToolsStatus] = configurationApi.useChangeToolsStatusMutation();
  const [getToolPlugins] = configurationApi.useLazyGetToolsPluginQuery();
  const [getToolName] = configurationApi.useLazyGetToolsNameQuery();
  const [deleteTools] = configurationApi.useDeleteToolsMutation();
  // const [getConfigToolsList] =
  //   configurationApi.useLazyGetConfigToolsListQuery();
  const [TestConnection] = configurationApi.useTestConnectionMutation({});
  const [TestConnectionTenable] =
    configurationApi.useTestConnectionTenableMutation({});
  const [getToolDetailsById] =
    configurationApi.useLazyGetToolDetailsByIdQuery();
  const dispatch = useDispatch();
  const configurationState = useSelector((state) => state.configuration);
  const { userName, userRole } = useSelector(
    (state) => state.common.loggedUser
  );
  const notAllowedRoles = [
    "Application Manager",
    "Department Head",
    "Division Head",
  ];
  const userAccess = !userRole.some((role) => notAllowedRoles.includes(role));
  const isCancelNavigate = localStorage.getItem("isConfigClicked");
  const toolspage = Number(localStorage.getItem("toolsCurrentPage"));
  const {
    getToolsListData,
    toolsCountData,
    toolsidDta,
    toolsLoading,
    toolscountLoading,
  } = useSelector((state) => state.toolsApi);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  const [loguserName, setLogUserName] = useState(userName);
  const [totalPageCount, setTotalPageCount] = useState();
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPageNo, setCurrentPageNo] = useState(toolspage ? toolspage : 0);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [toolsDDLoading, setToolsDDLoading] = useState(false);
  const [deleteToolsLoading, setdeleteToolsLoading] = useState(false);
  //State variable
  const [state, setState] = useState({
    limit: 10,
    page: 0,
    count: 0,
    toolList: [],
    totalPages: 1,
    checked: false,
    initialLoad: true,
    action: "",
    deleteId: "",
    typeError: false,
    typeErrorMessage: "",
    userNameError: false,
    userNameErrorMessage: "",
    accessKeyError: false,
    accessKeyErrorMessage: "",
    toolNameError: false,
    toolNameErrorMessage: "",
    secretAccessKeyError: false,
    secretAccessKeyErrorMessage: "",
    passwordError: "",
    passwordErrorMessage: "",
    urlError: false,
    urlErrorMessage: "",
    modalOpen: false,
    addBodyOpenTools: false,
    loadPage: false,
    conformationPop: false,
    getToolPluginData: [],
    getToolsNameData: [],
    formData: {
      id: "",
      type: "",
      toolName: "",
      toolStatus: "",
      userName: "",
      password: "",
      url: "",
      apiToken: "",
      sslValue: 0,
      accessKey: "",
      secretAccessKey: "",
    },
  });

  const navigate = useNavigate();
  const downloadReport = (toolName) => {
    fetch(`${proxy}/entitlement/report?toolName=${toolName}`).then(
      (response) => {
        if (response.status === 200) {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = `${toolName}.csv`;
            a.click();
          });
          return;
        } else {
          callCommonAlert("error", "Something went wrong. Please try again.");
          hideCommonAlert();
          hideAlert();
        }
      }
    );
  };

  const getpayload = (key) => {
    const TablePayload = {
      keyword: typeof key !== "undefined" ? key : searchInputValue,
    };
    return TablePayload;
  };

  const changeToolStatus = async (row, checked) => {
    const toolStatus = checked ? "ACTIVE" : "INACTIVE";
    // setStatusLoading(true);
    const Tablepayload = getpayload();
    changeToolsStatus({ id: row.id, status: toolStatus, userName })
      .then((data) => {
        const updatedArray = state.toolList.map((tool) => {
          if (tool.id === row.id) {
            return {
              ...tool,
              toolStatus,
            };
          }
          return tool;
        });
        if (data.data.statusCodeValue === 202) {
          callAlert(data.data.body, "success");
          setState((state) => ({
            ...state,
            toolList: updatedArray,
          }));
          hideAlert(true);
          fetchData(currentPageNo, pageLimit, Tablepayload);
        } else if (data.data.statusCodeValue === 400) {
          setState((state) => ({
            ...state,
            isDropDownhide: true,
          }));
          callAlert(data.data.body, "error");
          hideAlert();
          fetchData(currentPageNo, pageLimit, Tablepayload);
        }
      })
      .catch((err) => {
        setState((state) => ({
          ...state,
          isDropDownhide: true,
        }));
        callAlert("Something went wrong please try again.", "error");
        hideAlert();
        fetchData(currentPageNo, pageLimit, Tablepayload);
      });
  };


  const toolValidation = () => {
    let valid = true;
    const errors = {};

    const { formData } = state;
    const { toolName } = formData;

    const toolsurl = new RegExp(
      "^(https?|jdbc|mysql)://[0-9a-zA-Z][-.w0-9a-zA-Z]{0,200}(:[0-9]{1,5})?/?[a-zA-Z0-9-.?,'/\\+&%$#_]{0,500}$"
    );

    // Build validation rules dynamically from the API field config.
    // Falls back to basic username/password/url if no API config exists.
    const activeFieldKeys = getToolFieldConfig(state.toolsFieldsData, toolName);
    const dynamicRules = activeFieldKeys
      ? activeFieldKeys.map((key) => {
        const cfg = FIELD_UI_CONFIG[key];
        return {
          key: cfg.name,
          message: `*${cfg.label.replace("*", "").trim()} should not be empty`,
        };
      })
      : [
        { key: "userName", message: "*Username should not be empty" },
        { key: "password", message: "*Password should not be empty" },
        { key: "url", message: "*URL should not be empty" },
      ];

    const rules = [
      { key: "type", message: "*Please select a Type" },
      { key: "toolName", message: "*Please select a Tool Name" },
      ...dynamicRules,
    ];

    rules.forEach(({ key, message }) => {
      if (!formData[key] || formData[key] === "") {
        errors[`${key}Error`] = true;
        errors[`${key}ErrorMessage`] = message;
        valid = false;
      } else {
        errors[`${key}Error`] = false;
        errors[`${key}ErrorMessage`] = "";
      }
    });

    if (formData.url && !toolsurl.test(formData.url)) {
      errors.urlError = true;
      errors.urlErrorMessage = "*URL not valid";
      valid = false;
    }

    setState((prev) => ({ ...prev, ...errors }));
    return valid;
  };

  const callAlert = (msg, type) => {
    callCommonAlert(type, msg);
    setState((state) => ({
      ...state,
      isDropDownhide: true,
    }));
    hideCommonAlert();
  };
  const hideAlert = (loadPage = false) => {
    setTimeout(() => {
      setState((state) => ({
        ...state,
        loadPage,
      }));
    }, 2000);
  };

  useEffect(() => {
    setState({
      ...state,
      toolList: getToolsListData?.data,
      initialLoad: false,
    });
  }, [getToolsListData]);

  useEffect(() => {
    !state.initialLoad &&
      getToolPlugin().then(() => {
        getToolsName();
      });
  }, [state.action]);
  useEffect(() => {
    !state.initialLoad && getToolsName();
  }, [state.formData.type]);

  const getToolPlugin = async () => {
    try {
      const response = await getToolPlugins(timeStamp).unwrap();
      {
        state.action === "create" &&
          setState((state) => ({
            ...state,
            formData: {
              type: response ? response[0] : [],
            },
            getToolPluginData: response ? response : [],
          }));
      }
      const formatedType =
        !isEmpty(response) &&
        response.map((plugin) => ({
          label: plugin,
          value: plugin,
        }));
      dispatch(setToolsPlugin(formatedType));
    } catch (err) {
      console.log("Errors", err);
    }
  };

  const getToolsName = async () => {
    if (!state.formData.type) { return; } // prevent empty-type request → /toolsPlugin/?_=...
    try {
      const response = await getToolName({
        type: state.formData.type,
        timestamp: timeStamp,
      });
      if (response.status === "fulfilled") {
        const rawTools = Array.isArray(response?.data) ? response.data : [];
        // Extract the display name from each tool (API returns objects, not plain strings)
        const formatedToolName = rawTools.map((tool) => {
          const name = resolveToolName(tool);
          return { label: name, value: name };
        });
        dispatch(setToolsName(formatedToolName));
        const firstName = resolveToolName(rawTools[0] ?? "");
        setState((state) => ({
          ...state,
          getToolsNameData: rawTools,
          toolsFieldsData: rawTools, // full objects needed for dynamic field config
          formData: {
            ...state.formData,
            toolName: state.initialEdit ? state.formData.toolName : firstName,
          },
        }));
      }
    } catch (err) {
      console.log("Errors", err);
    }
  };

  const onChange = (name, value) => {
    const formattedValue = typeof value === 'string' ? value.trim() : value;

    if (name === "type" || name === "toolName") {
      removeValidation();
    }
    if (state[`${name}Error`]) {
      setState((state) => ({
        ...state,
        initialEdit: false,
        [`${name}Error`]: false,
        [`${name}ErrorMessage`]: "",
        formData: { ...state.formData, [name]: value },
      }));
      return;
    }

    setState((state) => ({
      ...state,
      initialEdit: false,
      formData: { ...state.formData, [name]: value },
      conformationPop: true,
    }));
  };
  const addmodalCloseTools = () => {
    setState((state) => ({
      ...state,
      addBodyOpenTools: true,
      typeError: false,
      typeErrorMessage: "",
      urlError: false,
      urlErrorMessage: "",
      passwordError: "",
      passwordErrorMessage: "",
      toolNameError: false,
      toolNameErrorMessage: "",
      userNameError: false,
      userNameErrorMessage: "",
    }));
  };
  const addBodyCancelTools = () => {
    setState({
      ...state,
      addBodyOpenTools: false,
      typeError: false,
      typeErrorMessage: "",
      urlError: false,
      urlErrorMessage: "",
      passwordError: "",
      passwordErrorMessage: "",
      toolNameError: false,
      toolNameErrorMessage: "",
      userNameError: false,
      userNameErrorMessage: "",
    });
  };
  const addBodyTools = () => {
    return (
      <>
        <DiscardChanges
          title={state.action === "create" ? "add" : "edit"}
          discardClick={onCancel}
          cancelClick={addBodyCancelTools}
        />
      </>
    );
  };

  const onAdd = (e) => {
    // Clear tool name options so stale/broken Redux data never reaches the dropdown
    dispatch(setToolsName([]));
    setState({
      ...state,
      action: "create",
      initialEdit: false,
      typeError: false,
      typeErrorMessage: "",
      urlError: false,
      urlErrorMessage: "",
      userNameError: false,
      userNameErrorMessage: "",
      passwordError: "",
      passwordErrorMessage: "",
      toolNameError: false,
      toolNameErrorMessage: "",
      toolsFieldsData: [],
      formData: {
        id: "",
        userName: "",
        password: "",
        url: "",
        apiToken: "",
        sslValue: 0,
        accessKey: "",
        secretAccessKey: "",
        model: "",
        type:
          configurationState?.toolsPlugin &&
            configurationState.toolsPlugin.length > 0
            ? configurationState.toolsPlugin[0].value
            : "",
        toolName: "", // getToolsName (triggered by action change) will auto-set this
      },
    });
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
  };

  const onDelete = async (data) => {
    setState((state) => ({
      ...state,
      modalOpen: true,
      deleteId: data.id,
    }));
  };

  const saveTool = (e) => {
    const tablepayload = getpayload();
    try {
      const toolValid = toolValidation();
      setState((state) => ({
        ...state,
        initialEdit: false,
      }));
      if (toolValid) {
        let {
          toolName,
          userName,
          id,
          url,
          type,
          apiToken,
          password,
          toolStatus,
          sslValue,
          accessKey,
          secretAccessKey,
        } = state.formData;

        const serverConfig =
          toolName.split(" ")[1] === "cloud" ? "CLOUD" : "SERVER";
        toolStatus = toolStatus ?? "ACTIVE";
        const idNum =
          state.action === "create"
            ? 0
            : id !== undefined && id !== null
              ? id + ""
              : 0;
        const payload = {
          toolName,
          userName,
          id: idNum,
          url,
          type,
          apiToken,
          password,
          serverConfig,
          toolStatus,
          sslValue,
          accessKey,
          secretAccessKey,
        };
        setSaveDisabled(true);
        setToolsDDLoading(true);
        const HTTP_STATUS = {
          OK: 200,
          CREATED: 201,
          BAD_REQUEST: 400,
        };

        createTools({ payload, loguserName })
          .then((data) => {
            const response = data.data || data;
            const { statusCodeValue, body } = response;

            setSaveDisabled(false);
            setToolsDDLoading(false);

            if (
              statusCodeValue === HTTP_STATUS.OK ||
              statusCodeValue === HTTP_STATUS.CREATED
            ) {
              callAlert(body, "success");
              dispatch(
                setIsOffCanvasOpen({
                  isDrilldownOpen: false,
                  isDropDownhide: false,
                })
              );
              fetchData(currentPageNo, pageLimit, tablepayload);
              hideAlert(true);
            } else if (statusCodeValue === HTTP_STATUS.BAD_REQUEST) {
              setState((state) => ({
                ...state,
                isDropDownhide: true,
              }));
              callAlert(body, "error");
              hideAlert();
            } else {
              callAlert(body || "Operation failed", "error");
              hideAlert();
            }
          })
          .catch((error) => {
            console.error("Error creating tools:", error);
            setSaveDisabled(false);
            setToolsDDLoading(false);
            callAlert("Failed to create tool. Please try again.", "error");
            hideAlert();
          });
      }
    } catch (err) {
      console.log("err");
    }
  };

  useEffect(() => {
    if (!isNaN(getToolsListData?.totalCount)) {
      setTotalPageCount(
        Math.ceil(getToolsListData?.totalCount / pageLimit) || 1
      );
    }
  }, [getToolsListData, pageLimit]);

  const fetchData = (pageNumber, itemsPerPage, payload) => {
    dispatch(getConfigToolsList({ pageNumber, itemsPerPage, payload }));
  };
  const removeStorage = () => {
    localStorage.removeItem("isConfigClicked");
    localStorage.removeItem("toolsCurrentPage");
  };

  useEffect(() => {
    const Tablepayload = getpayload();
    if (isCancelNavigate) {
      fetchData(toolspage, pageLimit, Tablepayload);
    } else {
      fetchData(0, pageLimit, Tablepayload);
    }
  }, []);

  const handlePageLimitChange = (newPageLimit) => {
    const tablepayload = getpayload();
    setPageLimit(newPageLimit);
    setCurrentPageNo(0);
    fetchData(0, newPageLimit, tablepayload);
    removeStorage();
  };

  const handlePageNoChange = (pageNumber) => {
    if (pageNumber === currentPageNo) {
      return;
    } else {
      const tablepayload = getpayload();
      setCurrentPageNo(pageNumber);
      fetchData(pageNumber, pageLimit, tablepayload);
      removeStorage();
    }
  };

  const onSearch = (key) => {
    if (key === searchInputValue) {
      return;
    } else {
      const Tablepayload = getpayload(key);
      setCurrentPageNo(0);
      setSearchInputValue(key);
      fetchData(0, pageLimit, Tablepayload);
      removeStorage();
    }
  };

  const onEdit = async (row) => {
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
    setState((state) => ({
      ...state,
      action: "edit",
      initialEdit: true,
      typeError: false,
      typeErrorMessage: "",
      urlError: false,
      urlErrorMessage: "",
      userNameError: false,
      userNameErrorMessage: "",
      passwordError: "",
      passwordErrorMessage: "",
      toolNameError: false,
      toolNameErrorMessage: "",
      formData: {
        id: row.id ? row.id : "",
        type: row.type ? row.type : "",
        toolName: row.toolName ? row.toolName : "",
        toolStatus: row.toolStatus ? row.toolStatus : "",
        userName: row.userName ? row.userName : "",
        password: row.password ? row.password : "",
        url: row.url ? row.url : "",
        apiToken: row.apiToken ? row.apiToken : "",
        sslValue: Number(row.sslValue),
        accessKey: row.accessKey ? row.accessKey : "",
        secretAccessKey: row.secretAccessKey ? row.secretAccessKey : "",
      },
    }));
  };

  const onDeleteTool = () => {
    const tablepayload = getpayload();
    // try {
    deleteTools({ id: state.deleteId, loguserName })
      .unwrap(setdeleteToolsLoading(true))
      .then((data) => {
        setdeleteToolsLoading(false);
        if (data?.statusCodeValue === 200) {
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          callAlert(data?.body, "success");
          if ((getToolsListData?.totalCount - 1) % 10 === 0) {
            setCurrentPageNo(
              currentPageNo == 0 ? currentPageNo : currentPageNo - 1
            );
          }
          fetchData(currentPageNo, pageLimit, tablepayload);
          hideAlert(true);
        } else if (data?.statusCodeValue == 400) {
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          callAlert(data?.body, "error");
          hideAlert(true);
        } else if (data?.error) {
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          callAlert("Something went wrong please try again.", "error");
          hideAlert(true);
        }
      });
  };
  const removeValidation = () => {
    setState({
      ...state,
      typeError: false,
      userNameError: false,
      urlError: false,
      passwordError: false,
      accessKeyError: false,
      secretAccessKeyError: false,
      toolNameError: false,
    });
  };
  const onCancel = () => {
    setState({
      ...state,
      action: "",
      typeError: false,
      userNameError: false,
      urlError: false,
      passwordError: false,
      toolNameError: false,
      accessKeyError: false,
      secretAccessKeyError: false,
      formData: {
        id: "",
        type: "Plan",
        toolName: "Jira",
        userName: "",
        password: "",
        url: "",
        apiToken: "",
        sslValue: "",
        accessKey: "",
        secretAccessKey: "",
      },
    });
    dispatch(hideOffCanvas(false));
    conformation();
  };
  const conformation = () => {
    setState({
      ...state,
      conformationPop: false,
      addBodyOpenTools: false,
    });
  };
  const modalHide = () => {
    setState((state) => ({
      ...state,
      modalOpen: false,
    }));
  };
  const setSessionStorage = () => {
    localStorage.setItem("toolsCurrentPage", currentPageNo);
    localStorage.setItem("isConfigClicked", true);
  };

  const renderModalBody = () => {
    return (
      <>
        <h4>Delete Tool</h4>
        {deleteToolsLoading ? (
          <Spinners />
        ) : (
          <div>
            <p>Please confirm do you want to delete this Tool?</p>
            <div className="btnswrap">
              <ButtonComponent
                text="Cancel"
                className={"cancelBtnStyle btn btn-primary"}
                onClick={modalHide}
              />
              <ButtonComponent
                text="Delete"
                className={"btnStyle btn btn-primary"}
                onClick={onDeleteTool}
              />
            </div>
          </div>
        )}
      </>
    );
  };
  const testConnectionTenable = () => {
    const toolValid = toolValidation();
    if (toolValid) {
      let {
        toolName,
        userName,
        id,
        url,
        type,
        apiToken,
        password,
        toolStatus,
        sslValue,
        appUrl,
        executionId,
        nameSpace,
        configId,
        timeType,
        delay,
        scanProvider,
        accessKey,
        secretAccessKey,
      } = state.formData;
      const payload = {
        toolName,
        url,
        accessKey,
        secretAccessKey,
      };
      setToolsDDLoading(true);
      TestConnectionTenable(payload).then((data) => {
        if (data.data.statusCodeValue === 202) {
          callCommonAlert("success", data.data.body);
          hideCommonAlert();
          hideAlert();
          setToolsDDLoading(false);
        } else {
          callCommonAlert("error", data.data.body);
          hideCommonAlert();
          hideAlert();
          setToolsDDLoading(false);
        }
      });
    }
  };
  const testConnection = () => {
    const toolValid = toolValidation();
    if (toolValid) {
      let {
        toolName,
        userName,
        id,
        url,
        type,
        apiToken,
        password,
        toolStatus,
        sslValue,
        accessKey,
        secretAccessKey,
      } = state.formData;
      const serverConfig =
        toolName.split(" ")[1] === "cloud" ? "CLOUD" : "SERVER";
      toolStatus = toolStatus ?? "0";
      const payload = {
        toolName,
        userName,
        id,
        url,
        type,
        apiToken,
        password,
        serverConfig,
        toolStatus,
        sslValue,
        accessKey,
        secretAccessKey,
      };
      setToolsDDLoading(true);
      TestConnection(payload)
        .then((data) => {
          if (data.data.statusCodeValue === 200) {
            callAlert(data.data.body, "success");
            setToolsDDLoading(false);
            hideAlert(true);
          } else if (data.data.statusCodeValue === 400) {
            setState((state) => ({
              ...state,
              isDropDownhide: true,
            }));
            callAlert(data.data.body, "error");
            setToolsDDLoading(false);
            hideAlert();
          }
        })
        .catch((err) => {
          setState((state) => ({
            ...state,
            isDropDownhide: true,
          }));
          callAlert("Something went wrong please try again.", "error");
          setToolsDDLoading(false);
          hideAlert();
        });
    }
  };

  const tableHeaders = [
    {
      Header: "Tool Name",
      accessor: "toolName",
      className: "text-start",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Type",
      accessor: "type",
      className: "text-start",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "URL",
      accessor: "url",
      className: "text-start",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Configuration",
      accessor: "configuration",
      thClassName: "text-center",
      Cell: ({ row }) => {
        let navigatePath = "";
        if (row.original.toolName) {
          if (row.original.toolName.toLowerCase().replace(" ", "") === "jira") {
            navigatePath = "jiraconfiguration";
          } else {
            navigatePath =
              row.original.toolName.toLowerCase().replace(" ", "") + "Role";
          }
        }
        console.log(navigatePath);
        if (navigatePath === "jfrogRole") {
          navigatePath = "jfrogRole";
        } else if (navigatePath === "sonarQubeRole") {
          navigatePath = "sonarQubeRole";
        } else if (navigatePath === "nexusiqRole") {
          navigatePath = "nexusRole";
        } else if (navigatePath.includes("tenable")) {
          navigatePath = "SeveritySLAConfigurationRole";
        }
        const encodedToolName = encodeURIComponent(row.original.toolName);
        console.log(encodedToolName);
        const handleClick = () => {
          if (props?.isDI) {
            navigate(
              `/configuration/administration/tools/jiraconfiguration`,
              { state: { row: row.original } }
            );
            setSessionStorage();
          }

          else if (userAccess) {
            navigate(
              `/configuration/administration/tools/${encodedToolName}`,
              { state: { row: row.original } }
            );
            setSessionStorage();
          }
        };

        if (row.original.config === true) {
          return (
            <a onClick={handleClick} title="Role Configuration"
              data-testid="configurationLink">
              <img src={settingsCode8} alt="setting" className="textCImag toolimg" />
            </a>
          );
        } else {
          return (
            <a title="Not Applicable"
              data-testid="notApplicableLink">
              <img src={StopNew} alt="setting" className="textCImag toolimg" />
            </a>
          );
        }
      },
    },
    {
      Header: "Status",
      accessor: "status",
      thClassName: "text-center",
      Cell: (row) => {
        return (
          <label className="toggle-control">
            <input
              type="checkbox"
              className="switchInput"
              data-testid="toggleInput"
              id={row.row.original.id}
              checked={row.row.original.toolStatus === "ACTIVE" ? true : false}
              onChange={(e) => {
                if (userAccess) {
                  changeToolStatus(row.row.original, e.target.checked);
                }
              }}
            />
            <span className="control"></span>
          </label>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "Action",
      className: "text-start",
      tdClassName: "text-center",
      thClassName: "actions",
      disableSortBy: true,
      Cell: (row) => (
        <div className="action-table">
          <div>
            <FiEdit
              title="Edit"
              className="iconStyleActions"
              data-testid="editIcon"
              onClick={() => {
                if (userAccess) {
                  onEdit(row.row.original);
                }
              }}
            />
          </div>
          <div>
            <FiTrash2
              title="Delete"
              data-testid={"deleteIcon"}
              className="iconStyleActions"
              onClick={() => {
                if (userAccess) {
                  onDelete(row.row.original);
                }
              }}
            />
          </div>
        </div>
      ),
    },
  ];
  const btnAdd = [
    {
      text: "Add",
      function: onAdd,
      className: !userAccess ? "accessDisabled" : "solid-btn",
      disabled: !userAccess,
    },
  ];
  return (
    <>
      <div className="grid-table p-0-5">
        <CompleteTableData
          isLoading={toolsLoading || statusLoading}
          data={state.toolList || []}
          columns={tableHeaders}
          listCount={getToolsListData?.totalCount}
          pageLimit={pageLimit}
          onPageNoChange={handlePageNoChange}
          onPageLimitChange={handlePageLimitChange}
          totalPageCount={totalPageCount}
          curentPageNumber={currentPageNo}
          btnData={btnAdd}
          onSearch={onSearch}
          searchKey={searchInputValue}
          moveSearchToEnd={true}
        />
        {/* )} */}
      </div>
      <div>
        <CustomOffCanvas className="custom-off-canvas" onCancel={onCancel}>
          <div className=" toolwrap custom_scroll">
            <h3
              className="flowhead p-0-5"
              id="updatehead"
              style={{ display: "block" }}
            >
              {state.action === "create" ? "New Tool" : "Update Tool"}{" "}
              <span>Please enter your tool data.</span>
            </h3>
            {toolsDDLoading ? (
              <Spinners />
            ) : (
              <form>
                <div className="row m-0">
                  <CustomSelectDropDown
                    containerClassName={
                      "frmgroup validate default-input col-6 "
                    }
                    labelName={"Type*"}
                    isSearchable={false}
                    placeholder={"Type"}
                    isDisabled={state?.action === "edit" ? true : false}
                    error={state.typeError}
                    errorMessage={state.typeErrorMessage}
                    options={configurationState?.toolsPlugin}
                    value={
                      Array.isArray(configurationState?.toolsPlugin)
                        ? configurationState.toolsPlugin.find(
                          (tool) => tool.value === state.formData.type
                        )
                        : []
                    }
                    name="Type"
                    onChange={(choice, action) =>
                      onChange("type", choice.value)
                    }
                  />
                  <CustomSelectDropDown
                    containerClassName={
                      "frmgroup validate default-input col-6 "
                    }
                    isSearchable={false}
                    placeholder={"Tool Name"}
                    labelName={"Tool Name*"}
                    error={state.toolNameError}
                    errorMessage={state.toolNameErrorMessage}
                    options={configurationState?.toolName}
                    isDisabled={state?.action === "edit" ? true : false}
                    value={configurationState?.toolName?.find(
                      (tool) => tool.value === state.formData.toolName
                    )}
                    name="Tool Name"
                    onChange={(choice, action) =>
                      onChange("toolName", choice.value)
                    }
                  />
                  <ToolFormFields
                    toolsFieldsData={state.toolsFieldsData}
                    toolName={state.formData.toolName}
                    formData={state.formData}
                    state={state}
                    onChange={onChange}
                    action={state.action}
                  />
                  <FormCheck
                    onChange={(e) =>
                      onChange(e.target.name, Number(e.target.checked))
                    }
                    name="sslValue"
                    checked={state.formData.sslValue}
                    bottomTitle={"Skip SSL"}
                  />
                  <div className="server-btn">
                    <ButtonComponent
                      text="Test Connection"
                      className={"greenBtnStyle"}
                      onClick={
                        state.formData.toolName?.includes("Tenable")
                          ? testConnectionTenable
                          : testConnection
                      }
                    />

                    <ButtonComponent
                      text="Cancel"
                      className={"cancelBtnStyle"}
                      onClick={() => {
                        if (state.conformationPop) {
                          addmodalCloseTools();
                        } else {
                          onCancel();
                        }
                      }}
                    />

                    <ButtonComponent text="Save" onClick={() => saveTool()} />
                  </div>
                </div>
              </form>
            )}
          </div>
        </CustomOffCanvas>
        <div>
          <CustomModal
            modalOpen={state.modalOpen}
            modalBody={renderModalBody}
            modalHide={modalHide}
          />
          <CustomModal
            modalOpen={state.addBodyOpenTools}
            modalBody={addBodyTools}
            modalHide={addmodalCloseTools}
            closeBtn={true}
            closeBtnFuc={addBodyCancelTools}
          />
        </div>
      </div>
    </>
  );
};
export default Tools;
